// Shared booking-form styles as plain `sx` objects (migrated off `@mui/styles`/makeStyles,
// which is incompatible with MUI v6 + React 18 and can flash unstyled mid-render).
// Breakpoint note (MUI defaults xs 0 / sm 600 / md 900): an `sx` value set at a breakpoint
// key cascades upward, so `only()`/`down()` rules carry an explicit reset at the next key up.
export const commonStyles = {
    container: {
        padding: { xs: '10px', sm: '30px 0 0 0', md: '25px' },
    },
    title: {
        fontSize: { xs: 30, sm: 38 },
        color: 'rgba(20, 20, 42, 1)',
        lineHeight: '115%',
        letterSpacing: '-1px',
        fontWeight: 500,
        pb: '15px',
        pt: { xs: '25px', sm: 0 },
    },
    subtitle: {
        fontSize: { xs: 18, sm: 20 },
        fontWeight: 300,
        pb: { xs: '25px', sm: '40px' },
    },
    fieldInputSection: {
        padding: { xs: '10px 0', sm: '15px' },
    },
    fieldInputItem: {
        width: { xs: '100%', sm: '90%' },
        maxWidth: 500,
    },
    overflow: {
        maxHeight: { xs: 'unset', sm: '50vh' },
        overflowY: 'auto',
    },
    displayError: {
        fontSize: 80,
        fontWeight: 300,
        pb: '40px',
        color: 'red',
    },
    bookingButton: {
        height: 52,
        width: '100%',
        maxWidth: 450,
        backgroundColor: 'rgb(0 168 0)',
        color: 'white',
    },
    errorButton: {
        height: 52,
        width: '100%',
        maxWidth: 450,
        color: 'red',
        borderColor: 'red',
    },
    encryptSect: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: { xs: 'center', sm: 'flex-start' },
    },
    cardContainer: {
        maxWidth: { xs: 'unset', md: 550 },
        margin: { xs: 'auto', md: 0 },
        justifyContent: { xs: 'center', sm: 'flex-start', md: 'initial' },
    },
    extraTitle: {
        fontSize: { xs: 20, sm: 22 },
        color: 'rgba(20, 20, 42, 1)',
        lineHeight: '115%',
        letterSpacing: '-1px',
        fontWeight: 400,
        opacity: 0.85,
        pb: '7px',
    },
    quantityTitle: {
        fontSize: { xs: 19, sm: 22 },
        color: 'rgba(20, 20, 42, 1)',
        lineHeight: '115%',
        letterSpacing: '-1px',
        fontWeight: 400,
        opacity: 0.85,
        pb: { xs: 0, sm: '7px' },
    },
    extraDescription: {
        fontSize: 16,
        fontWeight: 300,
        lineHeight: { xs: '137%', sm: 'normal' },
    },
    extraItemQuantity: {
        display: 'flex',
        justifyContent: 'flex-end',
        mt: { xs: '15px', sm: 0 },
    },
    extraItemImage: {
        pr: '25px',
    },
    extraItemText: {
        pr: { xs: 0, sm: '40px' },
    },
    extraQuantityInner: {
        display: { xs: 'flex', sm: 'block' },
        width: { xs: '100%', sm: 'auto' },
        alignItems: { xs: 'center' },
        justifyContent: { xs: 'space-between' },
        pl: { xs: '10px', sm: 0 },
        pr: { xs: '10px', sm: 0 },
    },
    locationTitle: {
        fontSize: { xs: 17, sm: 19 },
        letterSpacing: '-.007rem',
        fontWeight: 400,
    },
    location: {
        fontSize: { xs: 16, sm: 18 },
        letterSpacing: '-.007rem',
        fontWeight: 300,
    },
    pickUpCheckBox: {
        padding: '10px 15px',
        borderRadius: '10px',
        '& .MuiTypography-body1': {
            fontSize: { xs: 21, sm: 24 },
            fontWeight: 500,
        },
        ml: { xs: 0, sm: '15px' },
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'primary.light',
        color: 'primary.main',
    },
    checkLabel: {
        fontSize: { xs: 16.5, sm: 18 },
        py: '10px',
        px: { xs: 0, sm: '15px' },
        fontWeight: 300,
    },
    disableView: {
        backgroundColor: 'black',
        opacity: 0.5,
    },
    dateSelect: {
        pr: { xs: 0, md: '15px' },
        maxWidth: { xs: 'unset', sm: 300 },
        mt: { xs: '15px', md: 0 },
        mb: { xs: '20px', md: 0 },
    },
    timeSelect: {
        pl: { xs: 0, md: '15px' },
        maxWidth: { xs: 'unset', sm: 300 },
        mb: { xs: '15px', md: 0 },
    },
} as const;
